module.exports = __webpack_public_path__ + "img/icon_02.ecf3863e.png";